namespace GeniuzPOS.ReportMasterData {
    export class Report_1406Columns {
        static columnsKey = 'ReportMasterData.Report_1406';
    }
}
